import { useState } from "react"
import { Link } from "@tanstack/react-router"
import { Menu } from "lucide-react"
import { Logo } from "@/components/logo"
import { NotificationBell } from "@/components/notification-bell"
import { DeskUserMenu } from "@/components/desk-user-menu"
import { ADMIN_NAV } from "@/lib/admin-nav"
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"

const activeLinkProps = {
  className: "mkt-nav-link mkt-nav-link--active",
}

/** Ink & lime chrome for the platform operator desk (/admin/*). */
export function AdminHeader() {
  const [open, setOpen] = useState(false)

  return (
    <header className="mkt-nav mkt-nav--app home-wf">
      <div className="home-wf-shell mkt-nav-inner">
        <Link to="/admin" className="home-wf-brand" aria-label="Hire admin">
          <Logo />
          <span className="sr-only">Admin</span>
        </Link>

        <nav className="mkt-nav-links" aria-label="Admin">
          {ADMIN_NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="mkt-nav-link"
              activeOptions={{ exact: item.to === "/admin" }}
              activeProps={activeLinkProps}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="mkt-nav-actions mkt-nav-actions--desktop">
          <span className="mkt-nav-bell">
            <NotificationBell viewAllPath="/recruit/notifications" />
          </span>
          <DeskUserMenu />
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger className="mkt-nav-menu-btn" aria-label="Open menu">
            <Menu className="size-5" />
          </SheetTrigger>
          <SheetContent side="right" className="mkt-nav-sheet home-wf">
            <SheetHeader>
              <SheetTitle className="text-left">Admin</SheetTitle>
            </SheetHeader>
            <nav className="mt-6 flex flex-col gap-1" aria-label="Admin mobile">
              {ADMIN_NAV.map((item) => (
                <SheetClose key={item.to} asChild>
                  <Link
                    to={item.to}
                    className="mkt-nav-link"
                    activeOptions={{ exact: item.to === "/admin" }}
                    activeProps={activeLinkProps}
                    onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </Link>
                </SheetClose>
              ))}
            </nav>
            <div className="mt-6 border-t border-[color:var(--wf-line)] pt-4">
              <DeskUserMenu variant="drawer" onNavigate={() => setOpen(false)} />
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  )
}
